<template>
  <div class="black_bg">
    <iframe :src="src" frameborder="0"  class="iframe">
    </iframe>
  </div>
</template>

<script>
export default {
    props:{
        src:{
            default:'https://pay.wenhua.com.cn/#/iframePay/1?from=starquant',
            type:String,
        }
    },
    created(){
        window.addEventListener('message',this.close)
    },
    methods:{
        close(el){
            this.$emit('close',el)
        }
    }
}
</script>

<style>
.black_bg {
    position: fixed;
    top:0;
    left:0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 999;
}
.iframe{
    width: 925px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
}
</style>